<template>
  <div class="camp p_t">
    <TopHead title="营地介绍"></TopHead>
    <div class="c_top_c">
      <div class="f_title">{{ydInfo.title}}</div>
      <div class="ctc_c" v-html="ydInfo.contentInfo"></div>
      <div class="c_img clear">
        <div class="d_i p_r" v-for="(item,index) in ydBanner" :key="index" @click="goToOut(item)">
          <van-image fit="cover" :src="item.imgUrl"/>
          <div class="p_a tag text_over">{{item.bannerName}}</div>
          <!--<van-image fit="cover" src="../assets/img/about_bg.png"/>-->
        </div>
      </div>
    </div>
    <div class="c_list">
      <div class="c_title p_r">
        <div class="cut p_a"><div>合作研学基地</div></div>
      </div>
      <van-pull-refresh v-model="loading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="items d_f ali_c" v-for="(item,index) in list" :key="index" @click="$router.push('/CampDetail?contentCode='+item.contentCode)">
            <van-image fit="cover" :src="item.coverUrl"/>
            <div class="flex_1">
              <div class="i_title">{{item.title}}</div>
              <div class="tags">
                <div v-for="(itm,idx) in item.tags" :key="idx" :class="idx == 1 ? 'blue' : ''">{{itm}}</div>
              </div>
              <div class="more">了解详情</div>
            </div>
          </div>

        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Camp",
    data() {
      return {
        ydInfo:{},
        jdInfo:{},
        ydBanner:[],
        params:{
          pageIndex:1,
          pageSize:10,
          columnCode:'yxjd',
        },
        list:[],
        loading:false,
        finished:false,
        refreshing: false, //是否刷新
      }
    },
    created(){
      this.queryContentByCode('ydjs');
      this.listContent();
      this.getBanner(7);
    },
    methods: {

      //banner跳转外链
      goToOut(row){
        if(row.linkUrl) window.location.href=row.linkUrl;
      },
      onRefresh(){
        this.list = [];
        this.finished = false;
        this.params.pageIndex = 1;
        this.listContent();
      },
      onLoad(){
        let me = this;
        if(me.loading) return
        let page = me.params.pageIndex;
        page = page ? page + 1 : 1;
        this.params.pageIndex = page;
        this.listContent();
      },
      //获取营地banner7
      getBanner(num){
        this.$api.listBanner({pageIndex:1,pageSize:100,position:num}).then(res => {
          this.ydBanner = JSON.parse(JSON.stringify(res.data.rows));
        })
      },
      listContent(){
        this.loading = true;
        this.$api.listContent(this.params).then(res => {

          this.loading = false;
          if (this.refreshing) {
            this.refreshing = false;
          }
          if(res.data.recordCount){
            this.list = this.list.concat(JSON.parse(JSON.stringify(res.data.rows)));
          }
          let list = res.data.rows;
          if (!list || list.length < this.params.pageSize) {
            this.finished = true;
          }
        })
      },
      //查询营地简介:ydjs
      queryContentByCode(code){
        this.$api.queryContentByCode(code).then(res => {
          if(code == 'ydjs'){
            this.ydInfo = JSON.parse(JSON.stringify(res.data));
          }
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  .c_list{
    .items{
      .more{
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        text-align: center;
        line-height: 25px;
        width: 75px;
        height: 25px;
        background: #FFFFFF;
        border: 1px solid #333333;
        border-radius: 13px;
        cursor: pointer;
      }
      .tags{
        div{
          display: inline-block;
          text-align: center;
          margin-bottom: 4px;
          padding: 0 5px;
          height: 17px;
          background: #FFFFFF;
          border: 1px solid #E52A2A;
          line-height: 17px;
          box-sizing: border-box;
          font-size: 10px;
          font-weight: 500;
          color: #E52A2A;
          margin-right: 5px;
          &.blue{
            border-color: #1893EA;
            color: #1893EA;
          }
        }
        margin-bottom: 25px;
      }
      .i_title{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 15px;
        font-weight: bold;
        color: #333333;
        /*height: 40px;*/
        margin-bottom: 8px;
      }
      .van-image{
        width: 203px;
        height: 119px;
        border-radius: 5px;
        margin-right: 13px;
      }
      border-bottom: 1px solid #F0F0F0;
      padding: 21px 0 12px;
    }
    .c_title{
      .cut{
        >div{
          margin: 0 auto;
          background-color: white;
          width: 120px;
          text-align: center;
        }
        width: 100%;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        top: -13px;
      }
      margin-bottom: 4px;
      height: 1px;
      border-bottom: 1PX solid #333333;
    }
    padding: 26px 13px;
  }
  .c_top_c{
    .c_img{
      >.p_r{
        .tag{
          bottom: 0;
          left: 0;
          width: 92px;
          height: 31px;
          text-align: center;
          line-height: 31px;
          font-size: 15px;
          font-weight: bold;
          color: #333333;
          background: rgba(255, 255, 255, 0.5);
          border-radius: 5px;
        }
        width: 303px;
        height: 161px;
        margin-right: 15px;
        border-radius: 5px;
        overflow: hidden;
        img{
          width: 100%;
          height: 100%;
        }
      }
      overflow-x: auto;
      white-space: nowrap;
    }
    .ctc_c{
      margin: 18px 0 30px;
    }
    border-bottom: 10px solid #F0F0F0;
    padding: 26px 13px 17px 13px;
  }

</style>
